import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from '../../../../services/translation/hooks/useTranslation';
import { SettingsIcon } from '../icons/SettingsIcon';
import { NavbarIconButtonWithLabel } from '../NavbarIconButtonWithLabel';

export const SettingsNavButton = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const active = location.pathname === '/settings';

  return (
    <NavbarIconButtonWithLabel
      active={active}
      label={t('Settings')}
      onClick={() => {
        if (location.pathname !== '/settings') {
          navigate('/settings');
        }
      }}
    >
      <SettingsIcon />
    </NavbarIconButtonWithLabel>
  );
};
